var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8356 6.86475L11.1668 3.31648C10.6119 2.89406 9.83731 2.89495 9.28328 3.31648L4.6145 6.86475C4.22944 7.15733 4 7.62065 4 8.10353V14.5544C4 15.9035 5.0965 17 6.44555 17H9.55807V13.6652C9.55807 13.297 9.85687 12.9982 10.225 12.9982C10.5932 12.9982 10.892 13.297 10.892 13.6652V17H14.0045C15.3536 17 16.4501 15.9035 16.4501 14.5544V8.10353C16.4501 7.62065 16.2206 7.15821 15.8356 6.86475Z",
    fill: "#BCBBB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.495d0c39598c7e2da0a7e00c99a0f08c.svg";
export { ForwardRef as ReactComponent };